import {defineRule, self} from '../Utilities/jss';
import {font} from './fonts';
import {theme as t} from './theme';

export const RsnPane = defineRule('.RsnPane', {
    ...self.element('root', {
        width: '100%',
        display: 'flex',
        padding: t.spacing['4'],
        gridTemplateColumns: 'auto 1fr auto',
        gap: t.spacing['3'],
        alignItems: 'center',
    }),
    ...self.element('iconFrame', {
        width: t.spacing['9'],
        height: t.spacing['9'],
        borderRadius: t.borderRadius.full,
        backgroundColor: t.colors.neutral['20'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ['& > .RsnPane__icon']: {
            width: t.spacing['5'],
            height: t.spacing['5'],
        },
    }),
    ...self.element('icon', {
        width: t.spacing['9'],
        height: t.spacing['9'],
        color: t.colors.neutral['90'],
        flexShrink: 0,
    }),
    ...self.element('textBlock', {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
        flexGrow: 1,
    }),
    ...self.element('text', {
        display: 'inline-flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden',
        ...self.modifier('primary', {
            ...font['text-xl-regular'],
            color: t.colors.neutral['100'],
        }),
        ...self.modifier('secondary', {
            ...font['text-m-regular'],
            color: t.colors.neutral['60'],
        }),
    }),
    ...self.element('textWrapper', {
        display: 'inline',
        overflow: 'hidden',
        ...self.modifier('truncate', {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
        }),
        ...self.modifier('stretch', {
            flex: 1,
        }),
    }),
    ...self.element('metaText', {
        textAlign: 'right',
        marginLeft: t.spacing['3'],
        whiteSpace: 'nowrap',
    }),
});
